import EfIcon from '@elem/ui/ef-icon';
import EfLink from '@elem/ui/ef-link';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.OtherC');
    const { locale = 'us' } = useRouter();
    const HAS_XCORE = ['us', 'ca'].includes(locale);

    return (
        <div className={`ef-container ${styles.TheComp2}`}>
            <div className="CompA-in">
                <div className="CompA-list">
                    <div className="CompA-item">
                        <EfIcon className="CompA-item-icon" pc="https://websiteoss.ecoflow.com/upload/image/1722587838233/t1.png" />
                        <div className="CompA-title">{t('a_title')}</div>
                        <div className="CompA-desc">{t('a_desc')}</div>
                    </div>
                    <div className="CompA-item">
                        <EfIcon className="CompA-item-icon" pc="https://websiteoss.ecoflow.com/upload/image/1722588446624/t2.png" />
                        <div className="CompA-title">{t('b_title')}</div>
                        <div className="CompA-desc">{t('b_desc')}</div>
                    </div>
                    <div className="CompA-item">
                        <EfIcon className="CompA-item-icon" pc="https://websiteoss.ecoflow.com/upload/image/1722588457899/t3.png" />
                        <div className="CompA-title">{t('c_title')}</div>
                        <div className="CompA-desc">{t('c_desc')}</div>
                        {HAS_XCORE && (
                            <EfLink href={`/${locale}/x-core-3`} className="CompA-btn">
                                {t('c_btn')}
                            </EfLink>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
